import { Currency } from '@seaber/common/graphql/types';
import { formatCurrency } from '../../../lib/format';

export function calculateBreakEvenFreight(
  /** Total voyage cost for shipment */
  voyageCost: number,
  /** TC/OPEX cost for shipment */
  tcCost: number,
  /** Total cargo mass loaded during shipment */
  totalMass: number,
): number {
  if (totalMass === 0) return 0;
  const breakEvenFreight = (voyageCost + tcCost) / totalMass;
  return breakEvenFreight;
}

export function formatBreakEvenFreight(
  breakEvenFreight: number,
  currency: Currency = Currency.EUR,
) {
  return `${formatCurrency(breakEvenFreight, 2, currency)}/mts`;
}
